<template>
  <div class="mgv2__chip" :class="{ 'mgv2__chip--checked': checked }" @click="toggleChip">
    {{ label }}
  </div>
</template>

<script>
export default{
  props: ['label', 'checked', 'parent'],
  methods: {
    toggleChip() {
      this.$emit('toggle', this.label, this.checked, this.parent); // Emit an event to notify the parent component about the toggle action
    }
  }
}
</script>
